/* Membership enrolment gate. Markup lives in snippets/eingedi-enrollment-agreement.liquid.

   Sequential by design: the agreement checkbox unlocks only once the terms panel
   has been scrolled to the end, and the enrol button unlocks only once a name is
   typed and the box is ticked. The signature travels to Stripe as
   client_reference_id so the commitment and the payment share a record. */

(function () {
  var root = document.getElementById('EnrolGate');
  if (!root) return;

  var STRIPE = root.getAttribute('data-stripe');
  var terms  = document.getElementById('EnrolTerms');
  var cue    = document.getElementById('EnrolCue');
  var name   = document.getElementById('EnrolName');
  var date   = document.getElementById('EnrolDate');
  var wrap   = document.getElementById('EnrolAgreeWrap');
  var agree  = document.getElementById('EnrolAgree');
  var go     = document.getElementById('EnrolGo');
  var why    = document.getElementById('EnrolWhy');
  if (!terms || !go) return;

  var read = false;

  var d = new Date();
  date.value = d.getFullYear() + '-' +
    String(d.getMonth() + 1).padStart(2, '0') + '-' +
    String(d.getDate()).padStart(2, '0');

  function atEnd() {
    return terms.scrollTop + terms.clientHeight >= terms.scrollHeight - 8;
  }

  function markRead() {
    if (read) return;
    read = true;
    agree.disabled = false;
    wrap.setAttribute('aria-disabled', 'false');
    cue.setAttribute('data-read', '1');
    cue.textContent = 'Thank you — you have read the full terms.';
    refresh();
  }

  function refresh() {
    var typed = name.value.trim();
    var ok = read && agree.checked && typed.length >= 3 && !!date.value;
    go.disabled = !ok;
    if (!read) why.textContent = 'Read the terms above to continue.';
    else if (typed.length < 3) why.textContent = 'Type your full name to sign.';
    else if (!agree.checked) why.textContent = 'Tick the box above to confirm you agree.';
    else why.textContent = 'Payment is handled by Stripe. You will be charged $250 today.';
  }

  terms.addEventListener('scroll', function () { if (atEnd()) markRead(); });

  /* A short panel on a tall screen may never need scrolling; do not trap anyone. */
  if (terms.scrollHeight <= terms.clientHeight + 8) markRead();

  name.addEventListener('input', refresh);
  date.addEventListener('input', refresh);
  agree.addEventListener('change', refresh);

  go.addEventListener('click', function () {
    if (go.disabled) return;
    /* Stripe accepts only letters, digits, dashes and underscores here, and caps
       the value at 200 characters. Anything else is replaced rather than sent,
       because an invalid value makes Stripe reject the checkout outright. */
    var ref = (name.value.trim() + '-' + date.value)
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-{2,}/g, '-')
      .replace(/^-|-$/g, '')
      .slice(0, 190);
    var sep = STRIPE.indexOf('?') === -1 ? '?' : '&';
    window.location.href = STRIPE + sep + 'client_reference_id=' + encodeURIComponent(ref);
  });

  refresh();
})();
